<!--
component: BrowseGaiyo
author: Ken Nakamura
description: 建築計画概要書閲覧画面
-->
<template>
  <section>
    <!--<v-container fluid >-->
      <div class="split">
        <div class="split left-box" v-show="$vuetify.breakpoint.name != 'xs'">
          <v-container fluid>
            <v-row>
              <ZoomCanvas id="zoom-area" width="300" heigth="200"
                style="margin:5px;"
                :sourceImage="image" :zoom="zoomScale"
                :centerx="zoomCenterX" :centery="zoomCenterY"
              />
            </v-row>
            <v-row>
              <v-col v-for="(page, index) in pages" :key="index"
                cols="12" md="6" lg="6" xl="6" style="margin:0; padding:0;">
                <v-btn
                  @click="showPage(index)"
                  large width="95%"
                  class="lighten-3 text-h7 my-2 blue"
                  :class="{yellow: currentPage==index}" >
                  {{ page.name }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <v-btn  @click="printGaiyo" v-show="visiblePrint" :disabled="!enablePrint"
            dark color="#bb5577" x-large width="90%"
            class="text-h6 ml-2 mt-3 mb-1">
            <v-icon color="#dddddd" class="mx-1">mdi-printer</v-icon>
            {{printButtonCaption}}
          </v-btn>
          <v-btn  @click="printPage" v-show="enablePrintPage && enablePrint && visiblePrint"
            dark color="#55bb77" x-large width="90%"
            class="text-h6 ml-2 my-1">
            <v-icon color="#dddddd" class="mx-1">mdi-printer</v-icon>
            指定ページ印刷
          </v-btn>
          <v-btn  @click="goPlot" v-show="enableJumpPlot"
            dark color="#5577bb" large width="90%"
            class="text-h6 ml-2 my-1">
            <v-icon color="#dddddd" class="mx-1">mdi-map-marker</v-icon>
            プロット図
          </v-btn>

          <!-- 窓口端末での非表示を制御する内容が不確定なので一旦コメントアウト
          <div v-show="!isMadoguchi"> -->
          <div>
            <div style="margin:16px 16px 0px 16px;">申請はこちら</div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn  @click="goBrowseDaichoKakuShin"
                  color="#bb7755"  large width="90%" style="color: white;"
                  class="text-h6 ml-2 my-1" :disabled="!isBtnEnableKakuShin"
                  v-on="on">
                  <v-icon color="#dddddd" class="mx-1">mdi-file-document-check</v-icon>
                  確認申請台帳
                </v-btn>
              </template>
              <!-- 吹き出しに表示するメッセージ -->
              <span>・建築確認申請台帳記載事項証明書の記載内容の確認<br>・公印が押印された証明書の申請<br>をご希望の方はこのボタンを押してください。</span>
            </v-tooltip>
            <!--<details style="margin:0 16px;" large width="90%">
              <summary>詳細</summary>
            </details>-->
            <div v-if="!isBtnEnableKakuShin" style="margin:0px 8px;" x-large width="90%">
              本物件は建築確認申請台帳記載事項証明書の記載内容の確認・電子申請はできません。
            </div>
          </div>

        </div>
        <div class="split right-box" :style="$vuetify.breakpoint.name == 'xs'? 'width:90%':''">
          <browse-build :gaiyo="gaiyo" />
        </div>
        <v-btn
          v-show="$vuetify.breakpoint.name == 'xs'"
          @click="menuToggle = !menuToggle"
          color="rgb(88, 132, 163)"
          dark
          x-small
          class="px-0"
          max-width="3%"
          height="10%"
        >
          <v-icon>mdi-chevron-double-right</v-icon>
        </v-btn>
        <v-navigation-drawer
          v-model="menuToggle"
          absolute
          temporary
          color="rgb(198, 226, 225)"
        >
          <div class="px-2">
            <v-container fluid>
              <v-row>
                <ZoomCanvas id="zoom-area" width="300" heigth="200"
                  style="margin:5px;"
                  :sourceImage="image" :zoom="zoomScale"
                  :centerx="zoomCenterX" :centery="zoomCenterY"
                />
              </v-row>
              <v-row>
                <v-col v-for="(page, index) in pages" :key="index"
                  cols="12" md="6" lg="6" xl="6" style="margin:0; padding:0;" align="center">
                  <v-btn
                    @click="showPage(index)"
                    large width="95%"
                    class="lighten-3 text-h7 my-2 blue"
                    :class="{yellow: currentPage==index}" >
                    {{ page.name }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            <v-row>
              <v-col align="center">
                <v-btn  @click="printGaiyo" v-show="visiblePrint" :disabled="!enablePrint"
                  dark color="#bb5577" x-large width="90%"
                  class="text-h6 mt-3 mb-1">
                  <v-icon color="#dddddd" class="mx-1">mdi-printer</v-icon>
                  {{printButtonCaption}}
                </v-btn>
              </v-col>
              <v-col align="center">
                <v-btn  @click="printPage" v-show="enablePrintPage && enablePrint && visiblePrint"
                  dark color="#55bb77" x-large width="90%"
                  class="text-h6 my-1">
                  <v-icon color="#dddddd" class="mx-1">mdi-printer</v-icon>
                  指定ページ印刷
                </v-btn>
              </v-col>
              <v-col align="center">
                <v-btn  @click="goPlot" v-show="enableJumpPlot"
                  dark color="#5577bb" x-large width="90%"
                  class="text-h6 my-1">
                  <v-icon color="#dddddd" class="mx-1">mdi-map-marker</v-icon>
                  プロット図
                </v-btn>
              </v-col>
              <!--<v-col align="center" v-show="!isMadoguchi">-->
              <v-col align="center">
                <div style="margin:16px 16px 0px 16px;">申請はこちら</div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn  @click="goBrowseDaichoKakuShin"
                        color="#bb7755" x-large width="90%" style="color: white;"
                        class="text-h6 my-1" :disabled="!isBtnEnableKakuShin"
                        v-on="on">
                        <v-icon color="#dddddd" class="mx-1">mdi-file-document-check</v-icon>
                        確認申請台帳
                      </v-btn>
                    </template>
                    <!-- 吹き出しに表示するメッセージ -->
                    <span>・建築確認申請台帳記載事項証明書の記載内容の確認<br>・公印が押印された証明書の申請<br>をご希望の方はこのボタンを押してください。</span>
                  </v-tooltip>
                <div v-if="!isBtnEnableKakuShin" style="margin:0px 8px;" x-large width="90%">
                  本物件は建築確認申請台帳記載事項証明書の記載内容の確認・電子申請はできません。
                </div>
              </v-col>
            </v-row>
          </div>
        </v-navigation-drawer>
      </div>
    <!--</v-container>-->
    <Dialog error :open="pages.length==0" :ok="goBack"
      title="建築計画概要書" body="概要書データがありません。" />
    <Dialog error :open="browseLimitOver" :ok="goBack"
      title="建築計画概要書"
      :body="browseLimitMessage" />
  </section>
</template>

<script>
import BrowseBuild from '../components/BrowseBuild.vue'
import ZoomCanvas from '../components/ZoomCanvas.vue'
import Dialog from '../components/Dialog.vue'
import { CallApi,loadKisai } from '../common/apiAccess'

export default {
  components: {
    BrowseBuild,
    ZoomCanvas,
    Dialog,
  },
  data: () => {
    return {
      currentPage: 0,
      error: 0,
      browseLimitOver: false,
      image: null,    // オリジナル画像オブジェクト
      imageWidth: 0,  // オリジナル画像の幅
      imageHeight: 0, // オリジナル画像の高さ
      viewerRatio: 1, // 部分拡大窓の拡大率
      zoomScale: 1,   // ZoomImageViewerに渡すスケール値
      zoomCenterX: 0, // ZoomImageViewerに渡す画像中心X座標
      zoomCenterY: 0, // ZoomImageViewerに渡す画像中心Y座標
      menuToggle: false,
      updateCount: 0,

			isBtnEnableKakuShin: false,  // 「確認申請台帳」ボタンの禁則処理に使用
      isMadoguchi: false, // 

      targetUkeDay: null,
      //thresholdDate: '1996-03-31',  //  受付日によるボタン制御の閾値となる日付を「平成8年4月1日」としています userconfig.jsonで設定するため廃止

      daichoIdPattern: /^\d{10}$/,  // ges,m_gaiyoからのデータは建築物が1000000000,2000000000から始まる10桁の数字
                                    //balicsからのデータのIDは10桁の数字を想定していない
    }
  },
  props: {
    enablePrintPage: {
      type: Boolean,
      default: true,
    },
    enableJumpPlot: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
    gaiyo () {
      return this.$store.state.gaiyoData;
    },
    pages () {
      return this.$store.state.gaiyoPages;
    },
    ukeDay () {
      return this.$store.state.ukeDay;
    },
    ukeNo () {
      return this.$store.state.ukeNo;
    },
    printButtonCaption () {
      return this.enablePrintPage ? '全ページ印刷' : '印刷';
    },
    clientInfo () {
      return this.$store.state.clientInfo;
    },
    userInfo () {
      return this.$store.state.userInfo;
    },
    visiblePrint () {
      if (this.$store.state.controlPrintButton) {
        //return (this.clientInfo && this.clientInfo.category) ? this.clientInfo.category != 1 : true;
        return (this.userInfo && this.userInfo.authority) ?
          (this.userInfo.authority != 1 && this.userInfo.authority != 5) : true;
      }
      else {
        return true;
      }
    },
    enablePrint () {
      return true;
    },
    browseLimit() {
      return this.$store.state.browseCountLimit;
    },
    browseLimitMessage() {
      return `本日の閲覧可能上限数に到達しました。(１日の閲覧可能件数は${this.browseLimit}件です。)`
    },
    thresholdDate () {
      return this.$store.state.kakushinButtonThresholdDate;
    },
  },
  mounted () {
    if (this.unauthorized) {
      this.message = 'ユーザー認証されていません。';
      this.$router.replace('/');
    }
    this.$store.commit('setPrinting', false);
    this.$store.commit('setCurrentPage', 7);
    // balicsからのデータの場合
    if (this.gaiyo.kami != null){
      if (this.gaiyo.kami.data_kknnzumi === 1 || ["確認済", "確認済み"].includes(this.gaiyo.kami.annotation)) {
        this.message = `受付番号：${this.ukeNo}::`;
      }
      else if (this.gaiyo.kami.data_kakutei === 1 || this.gaiyo.kami.flg_kakutei === 1) {
        this.message = `受付番号：${this.ukeNo}:`;
      }
      else {
        this.message = `受付番号：${this.ukeNo}`;
      }
    }
    // 通常の処理(balics以外)
    else {
      if (this.gaiyo?.enableShobun) {
        this.message = `受付番号：${this.ukeNo}\u3000確認番号：${this.gaiyo?.kknnNo}`;
      }
      else {
        this.message = `受付番号：${this.ukeNo}`;
      }
      this.showPage(0);
    }

    const userInfo = this.$store.state.userInfo;
    if (userInfo.newUser && this.browseLimit > 0) {
      CallApi('BrowseCount', `?userId=${userInfo.userName}`, (data) => {
        if (data.errorCode) {
          // console.log(`BrowseCount error ${data.errorCode}:${data.message}`);
        }
        else {
          const count = data.count;
          const remain = this.browseLimit - count;
          if (remain < 0) {
            this.browseLimitOver = true;
          }
          else {
            this.$store.commit('setTitleMessage', `本日の閲覧可能件数：残り${remain}件`);
          }
        }
      });
    }

    this.handleBtnEnableKakuShin();

    // 窓口端末の判定
    if (this.$store.state.clientInfo.category == 1) {
      this.isMadoguchi = true;
    }
  },
  updated() {
    if(this.updateCount == 0){
      let range = new Range();
      range.selectNode(document.getElementsByClassName('footer')[0]);
      //range.getClientRects().length > 2 ? this.message = `受付番号：${this.ukeNo}` : this.message = `受付番号：${this.ukeNo}\u3000確認番号：${this.gaiyo?.kknnNo}`;
      if (this.gaiyo?.enableShobun) {
        range.getClientRects().length > 2 ? this.message = `受付番号：${this.ukeNo}` : this.message = `受付番号：${this.ukeNo}\u3000確認番号：${this.gaiyo?.kknnNo}`;
      }
      this.updateCount += 1;
    }
  },
  methods: {
    /**
     * 概要書の指定ページを表示する
     */
    showPage (pageNo) {
      this.currentPage = pageNo;
      this.$store.commit('setGaiyoPageNo', pageNo);
    },
    /**
     * 概要書を印刷する
     */
    printGaiyo () {
      if (this.gaiyo != null) {
        //test
        this.gaiyo.pageCount = this.pages.length;
        //
        this.$store.commit('addPrintList', this.gaiyo);
        //console.log(this.gaiyo.pageCount);
        this.$router.push('listprint');
      }
    },
    printPage () {
      //test
      if (this.gaiyo != null) {
        this.$store.commit('setPrinting', true);
        this.$store.commit('setSinglePrint', true);
        setTimeout(() => {
          window.print();
          this.$store.commit('setPrinting', false);
          this.$store.commit('setSinglePrint', false);
        });
      }
    },
    goPlot() {
      if (this.ukeNo) {
        CallApi('XY', `?uke_no=${this.ukeNo}`, (data) => {
          if (data) {
            if (data.errorCode) {
              switch (data.errorCode) {
                case 400:
                  break;
                case 404:
                  this.errorMessage = '対応する確認プロットが見つかりません。';
                  this.errorDialog = true;
                  break;
                default:
              }
            }
            else if (data.x) {
              this.$store.commit('setCenter', {x:data.x, y:data.y});
              this.$router.push({ name:'map', params:{targetPlot:data, zoom:19} });
            }
          }
        });
      }
    },


    goBrowseDaichoKakuShin() {
      this.$store.commit('setListAttrData', this.gaiyo);
      // .testメソッドは、正規表現にマッチするかどうかをチェックするメソッド
      if (this.gaiyo.daichoId && this.daichoIdPattern.test(this.gaiyo.daichoId)) {
        if (!this.gaiyo.kknnNo) {
          this.errorMessage = '未処分につき交付できません。';
          this.errorDialog = true;
          return;
        }

        // 10桁の番号の場合の処理
        this.searching = true;
        if (this.gaiyo.daichoId !== undefined) {
          this.controller = loadKisai(this.gaiyo.daichoId, (data) => {
            this.searching = false;
            this.apiData = data;
            if (data.errorCode == 401) {
              this.authDialog = true;
            }
            else if (data !== null && data.daichoId !== undefined) {
              if(data.cancel || data.drop || data.unBrowsable || data.unDisposed) {
                if (data.cancel) {
                  this.dialogMsg = '取止めにつき交付できません。\n表示しますか？';
                  this.dialogCategory = 0;
                  this.dialogFlg = true;
                }
                else if (data.drop) {
                  this.dialogMsg = '取下げにつき交付できません。\n表示しますか？';
                  this.dialogCategory = 0;
                  this.dialogFlg = true;
                }
                else if (data.unBrowsable) {
                  this.dialogMsg = '閲覧不可につき交付できません。\n表示しますか？';
                  this.dialogCategory = 0;
                  this.dialogFlg = true;
                }
                else if (data.unDisposed) {
                  this.dialogMsg = '未処分につき交付できません。\n表示しますか？';
                  this.dialogCategory = 0;
                  this.dialogFlg = true;
                }
              }
              else {
                this.$store.commit('setKisaiData', data);
                this.$store.commit('setKamiData', null);
                this.$router.push('BrowseDaichoKakuShin');
              }
            }
          });
        }
      } else if (this.gaiyo.kami) {
        // 紙台帳の場合の処理
        this.$store.commit('setKamiData', this.gaiyo.kami);
        this.$store.commit('setKisaiData', null);
        this.$router.push('BrowseDaichoKakuShin');
      }
    },
  
    goBack () {
      this.$router.back();
    },

    ukeNoHantei(){
      if (this.gaiyo.kami){
        this.isBtnEnableKakuShin = false;
      }

      else {
        const ukeNoGengo = this.gaiyo.ukeNo?.slice(0, 1);
        const ukeNoNendo = this.gaiyo.ukeNo?.slice(1, 3);

        if (ukeNoGengo == ("Ｈ" || "H")){
          if (["０４", "０５", "０６", "０７", "04", "05", "06", "07"].includes(ukeNoNendo)){
            this.isBtnEnableKakuShin = false;}
          else {this.isBtnEnableKakuShin = true;}
        }
        else {this.isBtnEnableKakuShin = true;}
      }
    },
    
    handleBtnEnableKakuShin(){
      // .testメソッドは、正規表現にマッチするかどうかをチェックするメソッド
      if (this.gaiyo.daichoId && this.daichoIdPattern.test(this.gaiyo.daichoId)) {
        if (this.ukeDay > this.thresholdDate) {
          this.isBtnEnableKakuShin = true;
        }
      }
      // balics(紙台帳)からのデータの場合
      else if (this.gaiyo.kami) {
        // 2026/01/29 ボタン活性化の条件が「受付日が閾値よりも新しい」のみに変更
        if (this.gaiyo.kami.uke_day > this.thresholdDate) {
          this.isBtnEnableKakuShin = true;
        }
        /*
        // 受付日が閾値よりも新しい & ("確定フラグが1" or "コメントが("確認済" or "確認済み" or null or "")")
        if ((this.gaiyo.kami.uke_day > this.thresholdDate)
          && (this.gaiyo.kami.data_kakutei == 1 || this.gaiyo.kami.flg_kakutei == 1)
          && ["確認済", "確認済み", null, ""].includes(this.gaiyo.kami.annotation)) {
          this.isBtnEnableKakuShin = true;
        }
        */
        else {this.isBtnEnableKakuShin = false;}
      }
      else {
        this.isBtnEnableKakuShin = false;
      }

    },
  },
}
</script>

<style lang="scss" scoped>
.split {
  position: absolute;
  width: /*98*/100%;
  //height: calc(100% - 12px);
  //height: 100%;
  height: calc(100% - 6px);
  //padding: 0.0em;
  padding: 0.3em 0;
  margin: 0;
  overflow: hidden;
}
.left-box {
  left: 0;
  width: 25%;
  min-width: 200px;
  height: calc(100% - 20px);
  padding: 0.3em;
  overflow-y: auto;
}
.right-box {
  right: 0;
  width: 75%;
  height: calc(100% - 20px);
  padding: 0 0.5em;
  overflow-y: scroll;
  overflow-x: auto;
  background-color: rgb(198, 226, 225);
}
.active {
  background-color: aquamarine;
}
@media print {
  .left-box {
    width: 0;
    visibility: hidden;
  }
  .right-box {
    width: 200mm;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
}
v-btn:disabled {
  background-color: rgb(36, 36, 36) !important;
  color: white !important;
  cursor: not-allowed !important;
}
</style>
